export async function fetchPageById(pageId: string) {
    const endpoint = `/umbraco/delivery/api/v1/content/item/${pageId}?expand=all`;
    try {
        const response = await fetch(endpoint);
        const responseAsJson = await response.json();
        //console.log("response (as json) from fetch page by id", responseAsJson);
        return responseAsJson;
    } catch (error) {
        console.error('Error retrieving news data', error);
    }
}

export async function fetchDescendantsWithSpecificContentType(pageId: string, numberOfDescendantsToFetch: number, contentType: string) {
    const endpoint = `/umbraco/delivery/api/v1/content?fetch=descendants:${pageId}&sort=publicationDate:desc&sort=createDate:desc&take=${numberOfDescendantsToFetch}&filter=contentType:${contentType}`;
    try {
        const response = await fetch(endpoint);
        const responseAsJson = await response.json();
        //console.log("response (as json) from fetch descendants", responseAsJson);
        return responseAsJson;
    } catch (error) {
        console.error('Error retrieving news data', error);
    }
}